import { useEffect, useRef } from "react"
import {
  headingsPlugin,
  imagePlugin,
  listsPlugin,
  markdownShortcutPlugin,
  MDXEditor,
  MDXEditorMethods,
  tablePlugin,
  thematicBreakPlugin,
} from "@mdxeditor/editor"
import dayjs from "dayjs"

import { ApiTypes } from "types"
import { ReactComponent as DateIcon } from "assets/svg/message-report-date.svg"
import { ReactComponent as MessageIcon } from "assets/svg/message-report-message.svg"
import { ReactComponent as TitleIcon } from "assets/svg/message-report-title.svg"

import decodeToMarkDown from "utils/markdown/decodeToMarkDown"

import styles from "./index.module.scss"

type HeaderTilesProps = {
  messageTemplate: ApiTypes.Model.MessageTemplateOld | undefined
}

export const HeaderTiles = ({ messageTemplate }: HeaderTilesProps) => {
  const { created_at: createdAt, title, body_rich: bodyRich } = messageTemplate || {}
  const editorRef = useRef<MDXEditorMethods>(null)

  useEffect(() => {
    if (bodyRich && editorRef.current) {
      editorRef.current.setMarkdown(decodeToMarkDown(bodyRich))
    }
  }, [bodyRich])

  return (
    <div className={styles.detailsWrapper}>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>
          <DateIcon className={styles.detailsIcon} />
          Date
        </h3>
        <div className={styles.detailsText}>{createdAt ? dayjs(createdAt).format("MM-DD-YYYY") : ""}</div>
      </div>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>
          <TitleIcon className={styles.detailsIcon} />
          Title
        </h3>
        <div className={styles.detailsText}>{title}</div>
      </div>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>
          <MessageIcon className={styles.detailsIcon} />
          Message
        </h3>
        <div className={styles.detailsText}>
          <MDXEditor
            className={styles.markdownWrapper}
            markdown={bodyRich ? decodeToMarkDown(bodyRich) : ""}
            readOnly={true}
            ref={editorRef}
            plugins={[
              headingsPlugin(),
              listsPlugin(),
              tablePlugin(),
              thematicBreakPlugin(),
              markdownShortcutPlugin(),
              imagePlugin(),
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default HeaderTiles
